import React, { useEffect, useReducer } from 'react';
import Room from './Room';
import { DEFAULT_PAX_VALUE } from '../../constants';
import {
  SET_EDIT_MODE,
  UPDATE_ROOM,
  REMOVE_ROOM,
  ADD_ROOM,
  MAX_ROOM_COUNT,
} from '../Constant/constants';
import PaxDispatch from './PaxDispatch';
import utils from '../../utils';
import { faOnAddRoom, faOnApplyChanges } from '../analytics-services';
import './PaxPickerV2.css';

const initialState = {
  value: DEFAULT_PAX_VALUE,
  editIndex: null,
};
const paxReducer = (state, action) => {
  switch (action.type) {
    case ADD_ROOM:
      // eslint-disable-next-line no-case-declarations
      const updatedVlaues = state.value.concat(DEFAULT_PAX_VALUE);
      return {
        editIndex: updatedVlaues.length - 1,
        value: updatedVlaues,
      };
    case REMOVE_ROOM:
      return {
        ...state,
        value: state.value.filter((room, index) => index !== action.index),
      };
    case SET_EDIT_MODE:
      return { ...state, editIndex: action.index };
    case UPDATE_ROOM:
      return {
        ...state,
        value: state.value.map((room, index) => (index === action.index ? action.room : room)),
      };
    default:
      throw new Error('No such action defined!');
  }
};

const PaxPickerV2 = ({
  value,
  handleChange,
  roomAdditionAllowed,
  roomsAndGuestsError,
  roomsAndGuestsErrorMessage,
  paxConfig,
  omniture,
  warningMessage,
}) => {
  const [{ value: pax, editIndex }, dispatch] = useReducer(paxReducer, {
    ...initialState,
    value: value || DEFAULT_PAX_VALUE,
  });
  const isRoomAddAllowed = roomAdditionAllowed || pax.length < MAX_ROOM_COUNT;

  useEffect(() => {
    const defaultOpen = pax?.length > 0 ? pax.length - 1 : null;
    dispatch({ type: SET_EDIT_MODE, index: defaultOpen });
  }, []);

  const onAddRoom = () => {
    omniture?.omnitureUtils?.captureOmnitureClick('add_room');
    faOnAddRoom(pax.length);
    dispatch({ type: ADD_ROOM });
  };

  const handleApplyClick = () => {
    if (utils.isValidPax(pax)) {
      faOnApplyChanges();
      handleChange(pax);
    }
  };

  useEffect(() => {
    if (!pax?.length) {
      dispatch({ type: ADD_ROOM });
    }
  }, [pax]);

  return (
    <div className="paxpicker-wrapper" data-testid="paxPickerV2">
      <div className="pax-container">
        <PaxDispatch.Provider value={dispatch}>
          {pax.map((room, index) => (
            <Room
              key={index}
              room={room}
              isEdit={editIndex === index}
              roomIndex={index}
              removable={index !== 0}
              paxConfig={paxConfig}
              omniture={omniture}
            />
          ))}
        </PaxDispatch.Provider>
        {roomsAndGuestsError && <p className="paxErrorText">{roomsAndGuestsErrorMessage}</p>}
      </div>
      {warningMessage && (
        <div className="cb-warning">
          <div className="holidaySprite warn-icon" />
          <span className="cb-warning-text">{warningMessage}</span>
        </div>
      )}
      <div className={`btnContainer ${isRoomAddAllowed ? '' : 'singleBtn'}`}>
        {isRoomAddAllowed && (
          <button type="button" className="addBtn" onClick={onAddRoom}>
            + ADD ANOTHER ROOM
          </button>
        )}
        <button type="button" className="applyBtn" onClick={handleApplyClick} id="applyBtn">
          APPLY
        </button>
      </div>
    </div>
  );
};

export default PaxPickerV2;
